import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type SportsBetsAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  action_type?: string;
  bet_type?: string;
  bet_settlement?: string;
  bet_money_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  target_user_id?: string;
  username?: string;
};

export type SportsBetsAALTableItem = {
  event_id: string;
  event_sort_key: string;
  created_at: string;
  action_type: string;
  agent_id: string;
  agent_email: string;
  agent_role_id: string;
  agent_role_name: string;
  target_user_id: string;
  target_username: string;
  bet_id: string;
  bet_type: string;
  bet_settlement: string;
  bet_market_name: string;
  bet_selection_name: string;
  bet_money_type: string;
  bet_timing: string;
  bet_wager_amount: number;
  bet_payout: number;
  amount_realized: number;
  bet_leg_index: number;
  bet_void_factor: number;
  promo_id: string;
  reason: string;
  bet_settled_at: string;
  bet_rolled_back_at: string;
  bet_cancelled_at: string;
};

export const useGetAALSportsBetsTable = (
  filters: SportsBetsAALTableFilters,
) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    action_type,
    bet_type,
    bet_settlement,
    bet_money_type,
    agent_id,
    agent_role_id,
    target_user_id,
    username,
  } = filters;

  return useAalListQuery<SportsBetsAALTableItem>("sports-bets", view, {
    start_date,
    end_date,
    page,
    size,
    sort,
    filters: {
      action_type,
      bet_type,
      bet_settlement,
      bet_money_type,
      agent_id,
      agent_role_id,
      target_user_id,
      username,
    },
  });
};
